import React, { useState, useEffect } from "react";
import { SettingNavbarComponent } from "../Components/navbar";
import { DashboardLayout, FormParser, PopupModal } from "../Components";
import { BiSearch } from "react-icons/bi";
import { Modal } from 'react-bootstrap';
import Masters from "../Components/masters.json";
import axiosConfig from "../Service/axiosConfig";
import DataTable from 'react-data-table-component';
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md"
import { FaHandHoldingHeart } from "react-icons/fa";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import useDebouncedValue from "../Utils/Debounce";

const AccountHead = () => {
    const [show, setShow] = useState(false);
    const MastersModal = Masters.AccountHead;
    const [formData, setFormData] = useState({});
    const [accountHeads, setAccountHeads] = useState([]);
    const [popupType, setpopupType] = useState("");
    const [Error, SetError] = useState('');
    const [message, setMessage] = useState("");
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [Id, SetId] = useState();
    const [loading, setLoading] = useState(false);
    const [modalTitle, setModalTitle] = useState("Add New Account Head");
    const [RowId, SetRowId] = useState();
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("")
    const [deletePopupType, setDeletepopupType] = useState("");
    const [search, setSearch] = useState("")
    const debouncedSearchTerm = useDebouncedValue(search, 500);
    const columns = [
        {
            name: "S No.",
            selector: (row, index) => index + 1,
        },
        {
            name: "Code",
            selector: "code",
            sortable: true
        },
        {
            name: "Title",
            selector: "title",
            sortable: true
        },
        {
            name: "Sort",
            selector: "sort",
            sortable: true
        },
        {
            name: "ACTIONS",
            selector: row => {
                const HandleEdit = async () => {
                    try {
                        setShow(true)
                        setModalTitle("Edit Account Head");
                        const response = await axiosConfig.get(`accounts/account-heads/${row.id}/`)
                        setFormData(response.data)
                    } catch (error) {
                        console.log(error)
                    }
                }
                const DeleteAlert = () => {
                    SetRowId(row.id)
                    SetAlertDeletePopupType("success")
                }
                const CancelAlerrt = () => {
                    SetAlertDeletePopupType("error")
                }
                const HandleDelete = async (row_id) => {
                    await axiosConfig.delete(`accounts/account-heads/${row_id}/`).then(() => {
                        SetAlertDeletePopupType("error")
                        setDeletepopupType("success")
                        GetAccountHeads();
                    }).catch((error) => {
                        setDeletepopupType("error")
                        SetAlertDeletePopupType("error")
                        console.log(error)
                    })
                }
                const handleRevive = async () => {
                    try {
                        const response = await axiosConfig.post(`accounts/account-heads/${row.id}/revive/`)
                        setpopupType("success")
                        setMessage("Account Head revived successfully")
                        GetAccountHeads()
                    } catch (error) {
                        console.log("Error While Reviving", error)
                    }
                }
                return (
                    <>
                        {Id === row.id ? (
                            row.is_suspended ? (
                                <FaHandHoldingHeart className="dashboard-tabe-data-actions" onClick={handleRevive} />
                            ) : (
                                <>
                                    <div className="row" >
                                        <div className="col-4">
                                            <MdOutlineEdit className="dashboard-tabe-data-actions" onClick={HandleEdit} />
                                        </div>
                                        <div className="col-4">
                                            <MdDeleteOutline className="dashboard-tabe-data-actions" onClick={DeleteAlert} />
                                        </div>
                                    </div>
                                </>
                            )
                        ) : (
                            <div className={`client-type ${row.is_suspended ? 'variable-background' : 'contract-background'}`}>
                                {row.is_suspended ? 'Suspended' : 'Active'}
                            </div>
                        )
                        }
                        {
                            AlertDeletePopupType === "success" &&
                            <AlertDeletePopupModal AlertDeletePopupType={AlertDeletePopupType} HandleDelete={HandleDelete} CancelAlerrt={CancelAlerrt} row={RowId} />
                        }
                    </>
                )
            }
        }
    ];
    const tableCustomStyles = {
        rows: {
            style: {
            },
        },
        cells: {
            style: {
                justifyContent: "center"
            },
        },
        headCells: {
            style: {
                color: "#5C5C5C",
                justifyContent: "center",
                color: "rgb(33,37,41)",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "28px",
            },
        },
    }
    const GetAccountHeads = async () => {
        setLoading(true)
        try {
            const response = await axiosConfig.get(`accounts/account-heads/?search=${search}`)
            console.log(response.data.results)
            setAccountHeads(response.data.results)
            setTotalRows(response.data.count)
            setLoading(false)
        } catch (error) {
            console.log("Error while fetching account heads", error)
        }
    }

    const HandleMouse = (row) => {
        SetId(row.id)
    }
    const HandleRowmouseLeave = () => {
        SetId()
    }

    const HandleShow = () => {
        setFormData({})
        setShow(true)
        setModalTitle("Add New Account Head")
    }

    const HandleClose = () => {
        setShow(false)
        SetError("")
    }

    const formSubmit = async (Data) => {
        console.log(Data);
        const formDataToSend = new FormData();
        formDataToSend.append("code", Data.code);
        formDataToSend.append("title", Data.title);
        formDataToSend.append("sort", Data.sort);
        axiosConfig.defaults.headers['Content-Type'] = 'multipart/form-data';
        try {
            let response;
            if (Data.id) {
                response = await axiosConfig.patch(`accounts/account-heads/${Data.id}/`, formDataToSend);
                console.log("updated account head successfully: ", response);
                setMessage("account head Updated Successfully");
            } else {
                response = await axiosConfig.post("accounts/account-heads/", formDataToSend);
                console.log("created account head successfully: ", response);
                setMessage("account head Created Successfully");
            }
            GetAccountHeads();
            setpopupType("success");
            setShow(false);
            SetError("")
        } catch (error) {
            console.log("Error setting account head : ", error);
            setpopupType("error");
            if (Object.values(error.response.data).length > 0) {
                SetError(Object.values(error.response.data)[0]);
            }
        }
    };


    useEffect(() => {
        GetAccountHeads()
    }, [debouncedSearchTerm])
    return (
        <>
            <DashboardLayout>
                <div className="child-sidenav">
                    <SettingNavbarComponent />
                    <div className="childnav-content mt-2">
                        <div class="cat-button">
                            <div class="btn" onClick={() => HandleShow()}>+ Add New</div>
                        </div>
                        <div className="input-cat-with-icon pe-0">
                            <span className="icon-product"><BiSearch /></span>
                            <input type="text" className="input-control" placeholder="Search" name="search" onChange={(e) => setSearch(e.target.value)} />
                        </div>
                        <div className="table-responsive marginTop">
                            <DataTable
                                columns={columns}
                                data={accountHeads}
                                pagination
                                paginationTotalRows={totalRows}
                                paginationPerPage={RowPerPage}
                                paginationDefaultPage={currentPage}
                                onChangePage={(page) => setCurrentPage(page)}
                                paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                onRowMouseEnter={HandleMouse}
                                onRowMouseLeave={HandleRowmouseLeave}
                                onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                                // onSort={handleSort}
                                paginationServer fixedHeader subHeader customStyles={tableCustomStyles} progressPending={loading}
                                progressComponent={<div className="loader-container">
                                    <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                                </div>}
                            />
                        </div>
                    </div>
                    <Modal size="lg" show={show} onHide={() => HandleClose()} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{modalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormParser modelObject={MastersModal} formData={formData} formSubmit={formSubmit} error={Error} />
                        </Modal.Body>
                    </Modal>
                    {popupType != "" &&
                        <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="" Message={message} error={Error} />
                    }
                </div>
            </DashboardLayout>
        </>
    )
}

export { AccountHead }